import { useMemo } from "react";
import { useGetTenantQuery } from "../graphql/generated/graphql";

/**
 * Returns the tenant's iframe-allowed domains for use with the HTML sanitizer.
 * Falls back to the policy defaults when the tenant has not configured the field.
 */
export function useIframeAllowedDomains(): string[] | undefined {
  const { data } = useGetTenantQuery({ fetchPolicy: "cache-first" });

  return useMemo(() => {
    const tenant = data?.getTenant?.data?.[0];
    return tenant?.htmlEmbedAllowedDomains?.filter(Boolean) as string[] | undefined;
  }, [data]);
}
